// Documentation: https://lingui.dev/tutorials/setup-vite
import { i18n } from "@lingui/core";
import { detect, fromNavigator } from "@lingui/detect-locale";

var supportedLangs =['ko', 'ja', 'en'];

export async function activateLanguage(locale: string) {
  if(!supportedLangs.includes(locale)) {
    locale = 'en';
  }
  const { messages } = await import(`./${locale}/messages.po`);
  i18n.load(locale, messages)
  i18n.activate(locale)
  console.log("Activated language", locale);
}

export var defaultLanguage = 'en';

export async function initateLingui() {
  const browserLang = detect(fromNavigator(), () => 'en');
  defaultLanguage = browserLang?.substring(0, 2) ?? 'en';
  await activateLanguage(defaultLanguage);
  document.documentElement.setAttribute("lang", defaultLanguage);
}
